/**
 * Tranches d'effectif recruteur — miroir admin de `src/constants/employeeRanges.ts`
 * (mobile) et des fonctions SQL `employee_range_*` (migration 080).
 */

export const EMPLOYEE_RANGE_CODES = ['1_9', '10_29', '30_49', '50_249', '250_plus'] as const;
export type EmployeeRangeCode = (typeof EMPLOYEE_RANGE_CODES)[number];

export const EMPLOYEE_RANGE_LABELS_FR: Record<EmployeeRangeCode, string> = {
  '1_9': '1 à 9 salariés',
  '10_29': '10 à 29 salariés',
  '30_49': '30 à 49 salariés',
  '50_249': '50 à 249 salariés',
  '250_plus': 'Plus de 250 salariés',
};

export function isEmployeeRangeCode(value: unknown): value is EmployeeRangeCode {
  return typeof value === 'string' && (EMPLOYEE_RANGE_CODES as readonly string[]).includes(value);
}

/** Entier historique -> tranche (profils antérieurs à la migration 080). */
export function employeeRangeFromCount(count: number | null | undefined): EmployeeRangeCode | null {
  if (count == null || !Number.isFinite(count) || count <= 0) return null;
  if (count <= 9) return '1_9';
  if (count <= 29) return '10_29';
  if (count <= 49) return '30_49';
  if (count <= 249) return '50_249';
  return '250_plus';
}

/**
 * Libellé affichable : tranche déclarée, sinon dérivée de l'entier, sinon null.
 * L'entier brut est rappelé entre parenthèses quand il ne vient pas d'une tranche
 * (valeur saisie librement avant la 080).
 */
export function employeeRangeDisplay(
  range: string | null | undefined,
  count: number | null | undefined,
): string | null {
  if (isEmployeeRangeCode(range)) return EMPLOYEE_RANGE_LABELS_FR[range];
  const derived = employeeRangeFromCount(count);
  if (!derived) return null;
  return `${EMPLOYEE_RANGE_LABELS_FR[derived]} (saisi : ${count})`;
}
